import React, { useState } from "react";
import { Button, Stack } from "@mui/material";
import Layout from "./Layout";
import Patients from "./Patients";

export default function DashboardHome() {
  const [view, setView] = useState("home");

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  return (
    <Layout title={view === "patients" ? "Patients" : "Overview"} onLogout={logout}>
      <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
        <Button variant="contained" onClick={() => setView("home")}>Home</Button>
        <Button variant="outlined" onClick={() => setView("patients")}>Patients</Button>
      </Stack>

      {view === "home" && (
        <div style={{ textAlign: "center" }}>
          <img
            src="https://cdn.pixabay.com/photo/2017/09/02/13/10/health-2706976_1280.jpg"
            alt="health"
            style={{ width: "100%", maxWidth: "600px", borderRadius: "12px", marginBottom: "20px" }}
          />
          <p>Welcome to HealthLink — your smart health data management system.</p>
        </div>
      )}

      {view === "patients" && <Patients />}
    </Layout>
  );
}
